import React from "react";
import styled from "styled-components";

const Container = styled.div`
    padding: 0 25px;
    max-width: 990px;
    margin: 0 auto 50px;
    display: block;
`
const HomepageLink = styled.a`
  cursor: pointer;
`
const HomepageAdImg = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 12px;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
`

function HomepageAds ({input}) {
    return (
        <Container>
            <HomepageLink href={input.primary.link.url} target="_blank">
                <HomepageAdImg src={input.primary.ad.url} />
            </HomepageLink>
        </Container>
    )
}

export { HomepageAds }